import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-view-notification',
  templateUrl: './view-notification.component.html',
  styleUrls: ['./view-notification.component.scss']
})
export class ViewNotificationComponent implements OnInit {

  @Input() selectedNotification;

  @Output("exitEvent") exitEvent : EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  exit(){
    this.exitEvent.emit();
  }

}
